import React, {PureComponent} from "react"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import appOnly from "@irati/ui/images/app_only.svg"

import {Container, Image} from "./styled"

class ViewPerkOnAppOnly extends PureComponent {
  render() {
    return (
      <Container>
        <Flex alignItems="center">
          <Image src={appOnly} />
          <Body small marginLeft={2} weight="semibold">
            <FormattedMessage id="perks.myPerks.viewPerkOnAppOnly.header" />
          </Body>
        </Flex>
      </Container>
    )
  }
}

export default injectIntl(ViewPerkOnAppOnly)
